import { inject, NgModule } from "@angular/core";
import { DxFileUploaderModule, DxTextAreaModule } from "devextreme-angular";
import { AttachViewService } from "src/app/services/attach-view.service";
import { FilePickerService } from "src/app/services/file-picker.service";
import { ProviderService } from "src/app/services/provider.service";
import { PopupService } from "./popup/popup.service";
import { CodiceFiscaleService } from "./codice-fiscale.service";
import { IndirizzoService } from "./indirizzo.service";
import { NavigationService } from "./navigation.service";
import { LockService } from "./lock.service";
import { FacilityService } from "./facility.service";
import { TitleService } from "./title.service";
import { MenuService } from "./menu.service";
import { DownloadService } from "./download.service";
import { PrintService } from "./print/print.service";
import { AvatarService } from "./avatar.service";
import { SidespaceService } from "./sidespace.service";
import { ModuleService } from "src/app/services/feature-access-control/module.service";
import { ReportService } from "src/app/services/report.service";
import { ViewerService } from "src/app/services/viewer/viewer.service";
import { TemplateService } from "src/app/services/template.service";
import { PlatformService } from "src/app/services/platform.service";
import { NotificationService } from "src/app/services/notification.service";
import { OpenPanelService } from "src/app/services/openpanel.service";
import { PdfService } from "src/app/services/pdf.service";
import { SessionService } from "src/app/services/session.service";
import { MedicalImageViewerService } from "./medical-image-viewer.service";
import { TabService } from "src/app/services/tab.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { DetachedRouteHandleService } from "src/app/services/detached-route-handle.service";
import { UpdateService } from "src/app/services/update.service";
import { DocumentService } from "src/app/services/document.service";
import { ValidationService } from "src/app/services/validation.service";
import { SettingsService } from "src/app/services/settings.service";
import { ColorService } from "src/app/services/color.service";
import { DetachedDomElementService } from "src/app/services/detached-dom-element.service";
import { VisibilityService } from "src/app/services/visibility.service";
import { ToastService } from "src/app/services/toast.service";
import { BeforeUnloadService } from "src/app/services/before-unload.service";
import { DirtyService } from "src/app/services/dirty.service";
import { UserService } from "src/app/services/user.service";
import { HealthRecordService } from "src/app/services/health-record.service";
import { RegionService } from "src/app/services/feature-access-control/region.service";
import { LicenseService } from "src/app/services/feature-access-control/license.service";
import { ScannerService } from "src/app/services/scanner.service";
import { ConfigurationService } from "src/app/services/configuration.service";
import { FeatureService } from "src/app/services/feature.service";
import { LocaleService } from "src/app/services/locale.service";
import { FiscalProfileService } from "src/app/services/fiscal-profile.service";
import { MemberStorageService } from "src/app/services/member-storage.service";
import { TasksService } from "src/app/services/tasks.service";
import { DateService } from "src/app/services/date.service";
import { IntegrationService } from "src/app/services/integration.service";
import { IFrameService } from "src/app/services/iframe.service";
import { AfterReloadMessagesNotifierService } from "src/app/services/after-reload-messages-notifier.service";
import { WysiwygService } from "src/app/services/wysiwyg.service";
import { DevxService } from "src/app/services/devx.service";
import { PWAService } from "src/app/services/pwa.service";
import { MemberService } from "src/app/services/member.service";
import { AsyncService } from "src/app/services/async.service";
import { BlobPrinterService } from "src/app/services/print/blob/blob-printer.service";
import { MobileBlobPrinterService } from "src/app/services/print/blob/mobile-blob-printer.service";
import { DesktopBlobPrinterService } from "src/app/services/print/blob/desktop-blob-printer.service";
import { OptimisticUiService } from "src/app/services/optimistic-ui.service";
import { MentionService } from "src/app/services/mention.service";
import { FormatterService } from "src/app/services/formatter.service";
import { StatusPageService } from "src/app/services/status-page.service";
import { LocalNetworkAccessService } from "src/app/services/local-network-access.service";
import { DraftDocumentStoreService } from "src/app/services/draft-document-store/draft-document-store.service";
import { FileSystemStorageService } from "src/app/services/file-system-storage.service";
import { StudyUploadManagerService } from "src/app/services/study-upload-manager.service";
import { UploadManagerService } from "src/app/services/upload-manager.service";
import { DicomService } from "src/app/services/dicom.service";
import { FileNamingService } from "src/app/services/file-naming.service";
import { CustomerSupportService } from "src/app/services/customer-support.service";
import { PinValidationService } from "src/app/services/pin-validation.service";
import { ProtectedTabService } from "src/app/services/protected-tab.service";
import { ChunkLoadRecoveryService } from "src/app/services/chunk-load-recovery.service";

@NgModule({
  imports: [DxTextAreaModule, DxFileUploaderModule],
  providers: [
    AttachViewService,
    FileSystemStorageService,
    StatusPageService,
    ProviderService,
    ConfigurationService,
    ScannerService,
    HealthRecordService,
    VisibilityService,
    DocumentService,
    SettingsService,
    UpdateService,
    DetachedRouteHandleService,
    LocalStorageService,
    TabService,
    SessionService,
    PopupService,
    CodiceFiscaleService,
    IndirizzoService,
    NavigationService,
    LockService,
    FacilityService,
    TitleService,
    MenuService,
    DownloadService,
    PopupService,
    PrintService,
    AvatarService,
    SidespaceService,
    ReportService,
    ViewerService,
    TemplateService,
    PlatformService,
    NotificationService,
    PdfService,
    MedicalImageViewerService,
    ValidationService,
    ColorService,
    DetachedDomElementService,
    ToastService,
    BeforeUnloadService,
    DirtyService,
    UserService,
    RegionService,
    LicenseService,
    ModuleService,
    FeatureService,
    LocaleService,
    FiscalProfileService,
    MemberStorageService,
    TasksService,
    DateService,
    IntegrationService,
    IFrameService,
    AfterReloadMessagesNotifierService,
    WysiwygService,
    PWAService,
    MemberService,
    AsyncService,
    DevxService,
    OptimisticUiService,
    OpenPanelService,
    MentionService,
    FormatterService,
    LocalNetworkAccessService,
    DraftDocumentStoreService,
    UploadManagerService,
    DicomService,
    StudyUploadManagerService,
    FileNamingService,
    FilePickerService,
    CustomerSupportService,
    PinValidationService,
    ProtectedTabService,
    ChunkLoadRecoveryService,
    {
      provide: BlobPrinterService,
      useFactory: () => {
        switch (inject(PlatformService).getDeviceType()) {
          case "desktop": {
            return new DesktopBlobPrinterService();
          }
          case "tablet":
          case "mobile": {
            return new MobileBlobPrinterService();
          }
        }
      }
    }
  ]
})
export class ServicesModule {}
